import Command from './command';
import CommandResult from './command-result';
import Constants from '@intercom/embercom-composer/lib/constants';
export default Command.extend({
  processZeroWidth() {
    if (this.get('firstSelectedBlock.isListType')) {
      return this._zeroWidthList();
    }
    if (this.get('firstSelectedBlock.isMedia')) {
      return this._mediaBlock();
    }
    if (this.get('firstSelectedBlock.isHeadingType') && this.get('selection.isAtStartOfBlock')) {
      return this._splitBeginningOfHeading();
    }
    if (this._shouldSplit()) {
      return this._doSplit();
    } else {
      return this.insertSoftReturn();
    }
  },
  processSingleBlock() {
    let newBlock;
    if (this.get('isFirstSelectedBlockCovered')) {
      this.removeFirstSelectedBlock();
      let insertPoint = this.get('selection.startBlockIndex');
      if (!this.get('firstSelectedBlock.isListType')) {
        this.insertDefaultBlock(insertPoint);
        insertPoint++;
      }
      newBlock = this.insertDefaultBlock(insertPoint);
      this.setSelectionToStartOf(newBlock);
      return CommandResult.create({
        newBlock
      });
    }
    if (this.get('firstSelectedBlock.isListType')) {
      return this._singleListBlock();
    }
    this.applyActionToFirstSelectedBlock('delete');
    this.collapseSelection();
    newBlock = this.applyActionToFirstSelectedBlock('split');
    this.insertBlock(newBlock);
    this.setSelectionToStartOf(newBlock);
    return CommandResult.create({
      newBlock
    });
  },
  processMultiBlock() {
    this.removeBlocks(this.get('coveredBlocks'));
    if (this.get('firstSelectedBlockNotCoveredAndNotList')) {
      this.applyActionToFirstSelectedBlock('delete');
    }
    if (this.get('lastSelectedBlockNotCoveredAndNotList')) {
      this.applyActionToLastSelectedBlock('delete');
    }
    if (this._shouldJoinLists()) {
      return this._joinLists();
    }
    if (this.get('firstSelectBlockNotCoveredAndIsList')) {
      return this._delegateToFirstSelectedBlock();
    }
    if (this.get('lastSelectBlockNotCoveredAndIsList')) {
      return this._delegateToLastSelectedBlock();
    }
    let insertPoint = this.get('selection.startBlockIndex');
    if (this.get('isFirstSelectedBlockNotCovered')) {
      insertPoint++;
    }
    let newBlock = this.insertDefaultBlock(insertPoint);
    this.setSelectionToStartOf(newBlock);
    return CommandResult.create({
      newBlock
    });
  },
  _zeroWidthList() {
    let blockList = this.get('firstSelectedBlock.blockList');
    let selection = this.get('firstSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    let numberOfItems = blockList.get('length');
    if (numberOfItems > 1 && selection.get('startBlockIndex') !== numberOfItems - 1 && selection.get('firstSelectedBlock.text') === '') {
      return this._splitListInTwo();
    }
    let result = this.constructor.create({
      blockList,
      selection,
      options: {
        forceSplit: true
      },
      config: this.get('config')
    }).run();
    let item = result.get('newBlock');
    let block = this.get('firstSelectedBlock');
    this.setSelectionToStartOfItem(block, item);
    this._checkForListTermination();
  },
  _checkForListTermination() {
    if (this.get('firstSelectedBlock.blockList.length') > 2 && this.get('firstSelectedBlock.blockList.lastObject.isBlank') && this.get('firstSelectedBlock.blockList.secondLastObject.isBlank')) {
      this.get('firstSelectedBlock.blockList').popObject();
      this.get('firstSelectedBlock.blockList').popObject();
      let insertPoint = this.get('selection.startBlockIndex') + 1;
      if (this.get('firstSelectedBlock.isEmpty')) {
        this.removeFirstSelectedBlock();
        insertPoint--;
      }
      this.setSelectionToStartOf(this.insertDefaultBlock(insertPoint));
    }
  },
  _splitListInTwo() {
    let newBlock = this.get('firstSelectedBlock').split(this.get('firstSelectedBlockItemSelection'));
    let paragraph = this.insertDefaultBlock();
    this.insertBlock(newBlock, this.get('selection.startBlockIndex') + 2);
    this.setSelectionToStartOf(paragraph);
    return CommandResult.create();
  },
  _mediaBlock() {
    let block;
    if (this.get('selection.startBlockIndex') === 0) {
      this.insertDefaultBlock(this.get('selection.startBlockIndex'));
      this.setSelectionToStartOf(this.get('firstSelectedBlock'));
    } else {
      block = this.insertDefaultBlock(this.get('selection.startBlockIndex') + 1);
      this.setSelectionToStartOf(block);
    }
    return CommandResult.create();
  },
  _singleListBlock() {
    let blockList = this.get('firstSelectedBlock.blockList');
    let selection = this.get('firstSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    let result = this.constructor.create({
      blockList,
      selection,
      options: {
        forceSplit: true
      },
      config: this.get('config')
    }).run();
    let item = result.get('newBlock');
    let block = this.get('firstSelectedBlock');
    this.setSelectionToStartOfItem(block, item);
  },
  _delegateToFirstSelectedBlock() {
    let blockList, selection, result, item, block;
    blockList = this.get('firstSelectedBlock.blockList');
    selection = this.get('firstSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    result = this.constructor.create({
      blockList,
      selection,
      options: {
        forceSplit: true
      },
      config: this.get('config')
    }).run();
    item = result.get('newBlock');
    block = this.get('firstSelectedBlock');
    this.setSelectionToStartOfItem(block, item);
    return CommandResult.create();
  },
  _delegateToLastSelectedBlock() {
    let blockList, selection, result, item, block;
    blockList = this.get('lastSelectedBlock.blockList');
    selection = this.get('lastSelectedBlockItemSelection');
    selection.set('blockList', blockList);
    result = this.constructor.create({
      blockList,
      selection,
      options: {
        forceSplit: true
      },
      config: this.get('config')
    }).run();
    item = result.get('newBlock');
    block = this.get('lastSelectedBlock');
    this.setSelectionToStartOfItem(block, item);
    return CommandResult.create();
  },
  _joinLists() {
    this.applyActionToFirstSelectedBlock('delete');
    this.applyActionToLastSelectedBlock('delete');
    this.setSelectionToEndOf(this.get('firstSelectedBlock'));
    this._setItemSelections();
    this.get('firstSelectedBlock').join(this.get('lastSelectedBlock'));
    this.removeBlock(this.get('lastSelectedBlock'));
    return this._delegateToFirstSelectedBlock();
  },
  _shouldJoinLists() {
    return this.get('firstSelectedBlock.isListType') && this.get('lastSelectedBlock.isListType') && this.get('isFirstSelectedBlockNotCovered') && this.get('isLastSelectedBlockNotCovered');
  },
  _shouldSplit() {
    let currentBlock = this.get('firstSelectedBlock');
    return this.get('options.forceSplit') || currentBlock.get('isMedia') || currentBlock.get('isListType') || currentBlock.get('type') === 'listItem' || currentBlock.get('type') === 'heading' || currentBlock.get('type') === 'subheading' || this._isSplitableTextBlock(currentBlock);
  },
  _isSplitableTextBlock(block) {
    return block.get('text') && !block.get('isCodeBlock') && this._getCharacterAtCaratOffset(-1) === Constants.NEW_LINE;
  },
  _doSplit() {
    this._stripNewlineForSplit();
    let newBlock = this.applyActionToFirstSelectedBlock('split');
    let insertPoint = this.get('selection.startBlockIndex') + 1;
    if (this.get('firstSelectedBlock.isMedia')) {
      insertPoint--;
    }
    this.insertBlock(newBlock, insertPoint);
    this.setSelectionToStartOf(newBlock);
    return CommandResult.create({
      newBlock
    });
  },
  _stripNewlineForSplit() {
    let currentBlock = this.get('firstSelectedBlock');
    if (!currentBlock.get('text')) {
      return;
    }
    if (this._getCharacterAtCaratOffset(-1) === Constants.NEW_LINE) {
      this.expandSelectionLeftBy(1);
    } else if (this._getCharacterAtCaratOffset(1) === Constants.NEW_LINE) {
      this.expandSelectionRightBy(1);
    }
    this.applyActionToFirstSelectedBlock('delete');
    this.collapseSelection();
  },
  _splitBeginningOfHeading() {
    this.insertDefaultBlock(this.get('selection.startBlockIndex'));
    this.setSelectionToStartOf(this.get('firstSelectedBlock'));
    return CommandResult.create({
      shouldRerender: true
    });
  },
  insertSoftReturn() {
    this.set('options', {
      character: Constants.NEW_LINE
    });
    let mutationResult = this.applyActionToFirstSelectedBlock('insertCharacter');
    return this.processBlockMutationResult(mutationResult);
  },
  _getCharacterAtCaratOffset(offset) {
    let currentBlock = this.get('firstSelectedBlock');
    let positionIndex = this.get('selection.startPositionIndex');
    if (currentBlock.get('text')) {
      if (offset < 0) {
        return currentBlock.get('text').slice(positionIndex + offset, positionIndex);
      } else {
        return currentBlock.get('text').slice(positionIndex, positionIndex + offset);
      }
    }
  }
});